import React from 'react';

import * as S from './styles';

// Types
import { HTMLAttributes, ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & (HTMLAttributes<HTMLDivElement>);

const CarouselItem = ({ children, ...rest }: Props) => {
  return <S.Item {...rest}>{children}</S.Item>;
};

export default CarouselItem;
